<template>
  <div>
    <v-form-designer
      ref="vform"
      :isDeleteIds="conditionsUseing"
    ></v-form-designer>
  </div>
</template>
<script>
import { saveFormDesign, getFormDesignData } from '@/api/tempApproval';
export default {
  props: {
    type: {
      type: String,
      default: 'create'
    },
    id: {
      type: String,
      default: ''
    },
    conditionsUseing: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      initFormDesiginData: {
        widgetList: [],
        formConfig: {
          modelName: 'formData',
          refName: 'vForm',
          rulesName: 'rules',
          labelWidth: 80,
          labelPosition: 'left',
          size: '',
          labelAlign: 'label-left-align',
          cssCode: '',
          customClass: '',
          functions: '',
          layoutType: 'PC',
          onFormCreated: '',
          onFormMounted: '',
          onFormDataChange: '',
          dataSources: [],
          onFormValidate: ''
        }
      }
    };
  },
  methods: {
    submitFormDesign(id) {
      return new Promise(resolve => {
        const vFormDom = this.$refs.vform;
        const json = vFormDom.getFormJson();
        const selectData = vFormDom.JSONFormData();
        const data = {
          formDef: { ...json, selectData },
          procTplConfigId: id
        };
        const flag = vFormDom.JSONSubmitValid();
        if (!flag) return;
        saveFormDesign(data).then(res => {
          const { code } = res.data;
          if (code == 200) {
            resolve(selectData);
          }
        });
      });
    },
    async getDetail() {
      const res = await getFormDesignData(this.id);
      const { data } = res.data;
      const { formJson } = data;
      const { selectData = [], ...rest } = formJson || {};
      const vFormDom = this.$refs.vform;
      const formJsonData = Object.keys({ ...rest }).length > 0 ? { ...rest } : this.initFormDesiginData;
      vFormDom.setFormJson(formJsonData);
      this.$emit('on-created', selectData);
    },
    createInit() {
      const vFormDom = this.$refs.vform;
      vFormDom.setFormJson(this.initFormDesiginData);
    }
  },
  mounted() {
    this.type == 'create' && this.createInit();
    this.type == 'edit' && this.getDetail();
  }
};
</script>
<style lang="less" scoped></style>
